<template>
<div class="chapter">
<div class="inner_page">
<p class="ser"><img alt="image" src="images/p10.jpg"/><a id="page_10"></a></p><a id="page_10">
<p class="fm1"><b>Lorraine Beaman, MA, ACRW, CARW, NCRW, CEIC, MCD</b></p>
<p class="txc">(866) 966-2665</p>
</a><p class="txc"><a id="page_10"></a><a href="mailto:Lorraine@interview2work.com" id="AU">Lorraine@interview2work.com</a></p>
<p class="txc"><a href="http://www.interview2work.com" id="A6E" target="_blank">www.interview2work.com</a></p>
<p class="txc"><a href="http://www.linkedin.com/in/lorrainebeaman/" id="AT-" target="_blank">www.linkedin.com/in/lorrainebeaman/</a></p>
<p class="txc"><a href="http://www.facebook.com/interview2work/" id="AF" target="_blank">www.facebook.com/interview2work/</a></p>
<p class="txc">Twitter: @interview2work</p>
<p class="txc">Instagram: Interview2work</p>
<p class="txt1">Interview2Work grew out of a passion to bring the most innovative job search strategies to college graduates working “survival” jobs because they were not successful securing jobs in their fields. During her thirty years of experience working with college students and serving as the director of career services for a regional business college, Ms. Beaman discovered it is not a lack of knowledge of their fields that cause new graduates to be underemployed, rather a lack of job search skills.</p>
<p class="tx">After multiple successful job placements among new college graduates, Ms. Beaman expanded Interview2Work’s services to include coaching on salary negotiation and how to effectively transition into a new job. Through these services, many of her clients have received starting salaries higher than they imagined and gained the skills necessary to successfully navigate their first days on the job.</p>
<p class="tx">Ms. Beaman holds several certifications including the prestigious AWRA, CARW, and NCRW in resume writing. She is a Certified Employment Interview Consultant and AAUW Salary Negotiation Facilitator. She also holds certificates in Negotiation and Leadership from Harvard University, job search applications of social networking, and strategies for those dealing with employment barriers. She is a member of Career Directors International, National Resume Writers Association, and Career Thought Leaders.</p>
<p class="tx">Ms. Beaman holds a Master’s degree from California State University, Chico, and a Bachelor’s degree from the University of California, Berkeley.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter11.vue?b8759b88